<template>
  <div>
    <div v-if="!loadingLogs && hasValidLogs">
      <div v-for="(log, index) in logs" :key="index" class="timeline-container">
        <div v-if="log.stack && log.stack.length">
          <div
            v-for="(cmd, stack_index) in log.stack"
            :key="stack_index"
            class="timeline-item"
          >
            <template v-if="cmd.type === 'cmd'">
              <p class="text-dark fw-semibold mb-1">
                {{ stack_index + 1 }}.
                {{ $t(`commands.list.${cmd.cmd_label || cmd.cmd_name}.name`) }}
              </p>
              <p class="mb-0 small" v-html="parseCmdData(cmd)"></p>
            </template>

            <template v-else>
              <p class="text-dark fw-semibold mb-1">
                {{ stack_index + 1 }}.
                {{ $t(`commands.list.${cmd.cmd_name}.name`) }}
              </p>
              <p class="mb-0 small">{{ cmd.data }} {{ $t("commands.units.seconds") }}</p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="!loadingLogs && !hasValidLogs" class="text-center text-muted p-3">
      <p class="mb-0">{{ $t("grid.slots.info.workflow_logs.no_workflow_data") }}</p>
    </div>

    <div v-else class="pb-2 text-center">
      <b-spinner v-if="loadingLogs" label="Cargando..." variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
import axios from "@axios";
import { BSpinner } from "bootstrap-vue";
import commandStackHelperMixin from "@/mixins/commandStackHelperMixin";

export default {
  mixins: [commandStackHelperMixin],
  components: {
    BSpinner,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      logs: null,
      loadingLogs: true,
    };
  },
  computed: {
    hasValidLogs() {
      return Array.isArray(this.logs) &&
        this.logs.length > 0 &&
        this.logs.some(log => log.stack && log.stack.length > 0);
    }
  },
  mounted() {
    this.getCommandLogByAlarmId(this.data.id)
      .then(({ data }) => {
        this.logs = data.data;
        this.$emit("has-workflow-log", this.hasValidLogs);
      })
      .finally(() => (this.loadingLogs = false));
  },
  methods: {
    getCommandLogByAlarmId(id_alarm) {
      return axios.get("/v1/command/command-log-by-alarm-id", {
        params: { id_alarm },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.timeline-container {
  padding: 1rem;
}
.timeline-item {
  border-left: 3px solid #1b3d5e;
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
  position: relative;
  .dark-layout & {
    border-left-color: var(--third-dark);
  }
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: -9px;
  top: 5px;
  width: 16px;
  height: 16px;
  background-color: #1b3d5e;
  border: 3px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 0 2px #1b3d5e;
}

.fw-semibold {
  font-weight: 600 !important;
}
.text-dark {
  color: #212529 !important;
}
.text-secondary {
  color: #6c757d !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.small {
  font-size: 0.875em;
}
</style>
